import React from 'react';
import {
    Label
} from 'shared/components/ui/label';
import {
    Select, SelectContent, SelectItem, SelectTrigger, SelectValue
} from 'shared/components/ui/select';
import {
    Switch
} from 'shared/components/ui/switch';
import NumberInput from '../../primitives/NumberInput';

/**
 * MemorySection — memory.{strategy, max_turns, max_tokens, ttl,
 * employee_memory}. Strategy "window" enforced; summary/full/hybrid
 * shown disabled until shipped (Q5.3).
 */
export default function MemorySection({
    a, onPatch
}) {
    const m = a.memory || {
        strategy: 'window',
        max_turns: 10,
        max_tokens: 4000,
        ttl: 86400,
        employee_memory: false
    };
    const setM = (updates) => onPatch({
        memory: {
            ...m,
            ...updates
        }
    });
    return (
        <div className="space-y-3">
            <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                <div>
                    <Label>Strategy</Label>
                    <Select value={m.strategy || 'window'} onValueChange={(v) => setM({
                        strategy: v
                    })}>
                        <SelectTrigger><SelectValue /></SelectTrigger>
                        <SelectContent>
                            <SelectItem value="window">window</SelectItem>
                            <SelectItem value="summary" disabled>summary · coming soon</SelectItem>
                            <SelectItem value="full" disabled>full · coming soon</SelectItem>
                            <SelectItem value="hybrid" disabled>hybrid · coming soon</SelectItem>
                        </SelectContent>
                    </Select>
                </div>
                <div>
                    <Label>Max turns</Label>
                    <NumberInput value={m.max_turns} onChange={(v) => setM({
                        max_turns: v
                    })} min={1} max={1000} />
                </div>
                <div>
                    <Label>Max tokens</Label>
                    <NumberInput value={m.max_tokens} onChange={(v) => setM({
                        max_tokens: v
                    })} min={100} max={100000} />
                </div>
                <div>
                    <Label>TTL (seconds)</Label>
                    <NumberInput value={m.ttl} onChange={(v) => setM({
                        ttl: v
                    })} min={60} />
                </div>
            </div>
            <div className="flex items-center gap-2">
                <Switch checked={!!m.employee_memory} onCheckedChange={(v) => setM({
                    employee_memory: v
                })} />
                <Label>Employee memory (auto-mirror every turn into employee scope)</Label>
            </div>
        </div>
    );
}
